import { TooltipProvider } from "@reactive-resume/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Outlet } from "react-router-dom";

import { helmetContext } from "../constants/helmet";
import { initGA } from "../libs/analytics";
import { queryClient } from "../libs/query-client";
import { AuthRefreshProvider } from "./auth-refresh";
import { DialogProvider } from "./dialog";
import { LocaleProvider } from "./locale";
import { ThemeProvider } from "./theme";
import { Toaster } from "./toaster";

export const Providers = () => {
  // 移动 GA 初始化到组件挂载后
  useEffect(() => {
    // 用 setTimeout 确保其他重要的初始化完成
    setTimeout(() => {
      initGA();
    }, 0);
  }, []);

  // 保持原有的渲染结构
  return (
    <LocaleProvider>
      <HelmetProvider context={helmetContext}>
        <QueryClientProvider client={queryClient}>
          <AuthRefreshProvider>
            <ThemeProvider>
              <TooltipProvider>
                <DialogProvider>
                  <Outlet />
                  <Toaster />
                </DialogProvider>
              </TooltipProvider>
            </ThemeProvider>
          </AuthRefreshProvider>
        </QueryClientProvider>
      </HelmetProvider>
    </LocaleProvider>
  );
};
